




import Vue from 'vue';
import Component from 'vue-class-component';
import Calendar, {ISchedule} from 'tui-calendar';
import 'tui-calendar/dist/tui-calendar.css';
import {Prop} from 'vue-property-decorator';
import {DEFAULT_CALENDAR_CONFIG} from '@/views/calendar/calendar.defaults';
import {CALENDER_UTILS_INSTANCE} from '@/views/calendar/calendar.utils';

@Component
export default class CalendarTemplate extends Vue {

    // the day we are looking for
    @Prop() day!: Date;
    @Prop() schedules!: ISchedule[];

    mounted() {
        setTimeout(() => {
            // create calendar
            const calendar = new Calendar('#calendar', DEFAULT_CALENDAR_CONFIG.calendarOptions);

            // set the current day
            calendar.setDate(this.day);
            calendar.createSchedules(this.schedules);
            // enforce synchronous rendering so that the steps below this line will work
            calendar.render(true);

            // needs rendered calendar
            CALENDER_UTILS_INSTANCE.highlightBusinessHours();
            // needs rendered calendar
            CALENDER_UTILS_INSTANCE.scrollToFirstBusinessHour();
        });
    }


}
